import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function PaymentLSSuccess() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const run = async () => {
      await refresh();
      setDone(true);
      toast.success("Payment confirmed! Plan activated.");
      setTimeout(() => nav("/dashboard"), 3000);
    };
    run();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grid-bg">
      <div className="w-full max-w-md glass-strong rounded-3xl p-10 text-center animate-fade-up">
        {done ? (
          <>
            <CheckCircle2 size={48} className="mx-auto text-emerald-400"/>
            <h1 className="mt-4 text-2xl font-bold" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Payment successful!</h1>
            <p className="text-sm text-zinc-400 mt-2">Your plan has been activated. Redirecting to dashboard…</p>
            <Loader2 size={18} className="mx-auto mt-4 animate-spin text-indigo-400"/>
          </>
        ) : (
          <>
            <Loader2 size={40} className="mx-auto text-indigo-400 animate-spin"/>
            <h1 className="mt-4 text-xl font-bold">Confirming payment…</h1>
            <p className="text-sm text-zinc-400 mt-2">Please wait while we activate your plan.</p>
          </>
        )}
      </div>
    </div>
  );
}
